// Global CSS is imported here and only here, in this order (docs/design/design-tokens-proposal.md §1).
import "./styles/fonts.css";
import "./styles/reset.css";
import "./styles/tokens.css";
import "./styles/themes/light.css";
import "./styles/themes/dark.css";
import "./styles/themes/paper.css";
import "./styles/global.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { AppErrorBoundary } from "./app/AppErrorBoundary";

const container = document.getElementById("root");
if (!container) throw new Error("index.html is missing the #root element");

createRoot(container).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
);
